"use strict";

exports.__esModule = true;
exports.getTitleOptions = void 0;
var getTitleOptions = exports.getTitleOptions = function getTitleOptions(title) {
  return {
    show: title == null ? void 0 : title.show,
    text: title == null ? void 0 : title.mainText,
    subtext: title == null ? void 0 : title.subText,
    left: title == null ? void 0 : title.verticalPosition,
    top: (title == null ? void 0 : title.horizontalPosition) === "bottom" ? "85%" : title == null ? void 0 : title.horizontalPosition,
    textStyle: {
      fontSize: title == null ? void 0 : title.mainFontSize,
      color: title == null ? void 0 : title.mainTextColor
    },
    subtextStyle: {
      fontSize: title == null ? void 0 : title.subFontSize,
      color: title == null ? void 0 : title.subTextColor
    }
  };
};